export type ApprovalType = "change_order" | "material_selection";
export type ApprovalStatus = "pending" | "approved" | "rejected" | "discussion";
export type ApprovalPriority = "normal" | "urgent";

export interface ApprovalLineItem {
  id?: string;
  description: string;
  quantity: number;
  unit_price: number;
}

export interface Approval {
  id: string;
  project_id: string;
  contractor_id: string;
  timestamp: string;
  title: string;
  description: string | null;
  type: ApprovalType;
  status: ApprovalStatus;
  pricing_breakdown: ApprovalLineItem[] | null;
  timeline_impact: number | null;
  priority: ApprovalPriority;
  photo_urls: string[] | null;
  client_response: string | null;
  client_response_date: string | null;
}

export interface ApprovalFormData {
  type: ApprovalType;
  title: string;
  description: string;
  lineItems: ApprovalLineItem[];
  timelineImpact: string;
  priority: ApprovalPriority;
}

export const approvalTypeOptions: { value: ApprovalType; label: string }[] = [
  { value: "change_order", label: "Change Order" },
  { value: "material_selection", label: "Material Selection" },
];

export const priorityOptions: { value: ApprovalPriority; label: string }[] = [
  { value: "normal", label: "Normal" },
  { value: "urgent", label: "Urgent" },
];

export const statusOptions: { value: ApprovalStatus; label: string }[] = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "discussion", label: "Needs Discussion" },
];
